// extracted by mini-css-extract-plugin
module.exports = {"spin":"Home_spin__VEV0f","vipButton":"Home_vipButton__6QKCc","blink":"Home_blink__F0rMx"};